import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {ListItemType} from 'hiya-common/src/reducers/commonTypes'
import {http} from 'hiya-common/src/utils/axios'

export enum rank_enum {
  明星榜 = 1,
  粉丝榜 = 2,
}
export enum PageTypeEnum {
  rules = 1,
  stars,
  fans,
}
export enum AnchorTypeEnum {
  // 海选赛
  qualifier = 1,
  // 分组赛
  track = 2,
  // 冲刺赛 第一天
  knockouts = 3,
  // 冲刺赛 第2天
  knockoutsSec = 4,
  // 冲刺赛 第3天
  knockoutsThird = 5,
}
export enum TrackEnum {
  // 黄金赛道
  gold = 1,
  silver = 2,
  bronze = 3,
}
export const areaChinese = {
  '0': '中东',
  '1': '印尼',
  '5': '泰国',
  '2': '越南',
  '6': '印度',
}

// 争霸赛信息http://wiki.xunlei.cn/pages/viewpage.action?pageId=96452210
export const star_war_info = createAsyncThunk(
  'star_war_info',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'race'
          | 'stage'
          | 'race_day_list'
          | 'race_day_index'
          | 'duration_index'
        >
      >
    >(
      '/live/activity/star_war_info',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 获取 基础信息 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=27690457
export const get_star_wars_rank_config = createAsyncThunk(
  'get_star_wars_rank_config',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'fans_id'
          | 'race_day_index'
          | 'duration_index'
          | 'race_day_list'
          | 'count_down'
        >
      >
    >(
      'live/commonactivity/get_star_wars_rank_config',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// top host 活动用户每日榜单数据  https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=27689597
export const get_star_wars_on_mic_status = createAsyncThunk(
  'get_star_wars_on_mic_status',
  // 需要传榜单id
  async (arg: {rank_id: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'on_mic_status' | 'on_mic_duration'>>
    >('live/commonactivity/get_star_wars_on_mic_status', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

// 查看榜单时，用户是否在赛道，用户在哪个赛道，用于查看赛道数据的时候，默认显示用户所在赛道
export const get_star_wars_track_status = createAsyncThunk(
  'get_star_wars_track_status',
  // 需要传榜单id
  async (arg: {race_day_index: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<InitialStateType, 'is_in_track' | 'track_index' | 'is_in_race'>
      >
    >('/live/commonactivity/get_star_wars_track_status', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// 明星争霸赛获取榜单某个人的数据 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=27690007

export const get_star_wars_rank_scores = createAsyncThunk(
  'get_star_wars_rank_scores',
  // 需要传榜单id
  async (arg: {rank_id: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'previous_score'
          | 'promote_scores'
          | 'track_forcast'
          | 'promote_track_score'
        >
      >
    >('/live/commonactivity/get_star_wars_rank_scores', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
interface HiyaRes<T> {
  ret: number
  data: T
}

interface RaceDayTYpe {
  stage?: AnchorTypeEnum
  name: string
  duration_list: Array<string>
  track_array: Array<{
    track_id: TrackEnum
    promote_line: number
    promote_rule: string
  }>
}
interface InitialStateType {
  // 用户当前所在赛道  如果当前赛段没有赛道 就是0
  race?: TrackEnum
  // 用户当前所在赛制 stage	int	1海选赛 2分组赛 3冲刺赛 如果当前不在比赛中就是0
  stage?: AnchorTypeEnum
  fans_id?: number
  race_day_list?: Array<RaceDayTYpe>
  race_day_index?: number
  // 表明目前处于第几阶段
  stage_count?: number
  // 处于第几阶段的第几天
  duration_index?: number
  count_down?: number
  // 明星争霸赛获取榜单某个人的数据
  promote_scores?: number
  previous_score?: number
  // 1| 2|3
  track_forcast?: number
  promote_track_score?: number
  // 是否在比赛中 否表示被淘汰
  is_in_race?: boolean
  // 用户所在赛道
  is_in_track?: boolean
  track_index?: number
  // 上麦状态
  on_mic_status?: number
  on_mic_duration?: Array<{time: string; point: number}>
  // 榜单信息
  own?: ListItemType
  list?: Array<ListItemType>
}
const initialState: InitialStateType = {}
export const StarWarsSlice = createSlice({
  name: 'StarWars',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(star_war_info.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(get_star_wars_rank_config.fulfilled, (state, action) => {
      const {race_day_list, ...rest} = action.payload
      // 防止数组返回null，直接重置成[]
      const ret = {
        race_day_list: race_day_list || [],
      }
      Object.assign(state, ret, rest)
    })
    builder.addCase(get_star_wars_rank_scores.fulfilled, (state, action) => {
      const data = action.payload
      // 防止数组返回null，直接重置成[]
      Object.assign(state, data)
    })
    builder.addCase(get_star_wars_track_status.fulfilled, (state, action) => {
      const data = action.payload
      // 防止数组返回null，直接重置成[]
      Object.assign(state, data)
    })
    builder.addCase(get_star_wars_on_mic_status.fulfilled, (state, action) => {
      const data = action.payload
      // 防止数组返回null，直接重置成[]
      Object.assign(state, data)
    })
  },
})
export default StarWarsSlice.reducer
